'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasePatternFactory = require('../lib/BasePatternFactory');

var _BasePatternFactory2 = _interopRequireDefault(_BasePatternFactory);

var _AndroidUARegex = require('../regex/AndroidUARegex');

var _AndroidUARegex2 = _interopRequireDefault(_AndroidUARegex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _BasePatternFactory2.default)({
  name: 'AndroidUA',
  validator: function validator(input) {
    return _AndroidUARegex2.default.test(input);
  }
});
module.exports = exports['default'];